/**
 * region for libraries*/
import React, { Component } from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

/**
 * region for component*/
import { KeywordsLog } from './KeywordsLog';
import { KeywordsAddedVsDeletedChart } from './KeywordsAddedVsDeletedChart';
import { RelationshipsAddedVsDeletedChart } from './RelationshipsAddedVsDeletedChart';
import { KeywordsModifiedChart } from './KeywordsModifiedChart';
import { WorkingLayer } from '../../../../components/common/WorkingLayer';
import { DateFilter } from '../../../../components/common/DateFilter';

/**
 * region for components*/
import InputSearchKeyword from '../../../../components/keyword/InputSearchKeyword';

/**
 * region for helpers*/
import ajax from '../../../../helpers/ajax';
import typing from '../../../../helpers/typing';

/**
 * region for constants*/
import Constants from '../../../../constants/Constants'

export class Activity extends Component {
    static displayName = Activity.name;

    constructor(props) {
        super(props);

        this.state = {
            mode: Constants.MODE_LOADING,
            staff: [],
            organizationTypes: [],
            filters: {},
            currentStaff: 'All Users',
            selectedDateValue: null,
            dropdownOpenStaff: false,
            dropdownOpenDate: false,
            beginDate: null,
            endDate: null,
            dropdownOpenTypes: false,
            currentOrganizationType: 'All Types',
            searchTerm: '',
            resetPage: false
        };
    }

    load() {
        const self = this;

        ajax.get(Constants.ROUTE_API_CONTENTORGANIZATION_STAFF,
            {
                success: function (response) {
                    self.setState({
                        mode: Constants.MODE_LOADED,
                        staff: response.data
                    });
                }
            });

        ajax.get(Constants.ROUTE_API_CONTENTORGANIZATION_TYPES,
            {
                success: function (response) {
                    self.setState({
                        mode: Constants.MODE_LOADED,
                        organizationTypes: response.data
                    });
                }
            });
    }

    componentDidMount() {
        this.load();
    }

    toggleStaff() {
        this.setState({
            dropdownOpenStaff: !this.state.dropdownOpenStaff
        });
    }

    toggleDate() {
        this.setState({
            dropdownOpenDate: !this.state.dropdownOpenDate
        });
    }

    toggleOrganizationType() {
        this.setState({
            dropdownOpenTypes: !this.state.dropdownOpenTypes
        });
    }

    handleChangeValue(staff, event) {
        event.preventDefault();
        let newFilter = {
            idStaff: staff.IDSTAFF
        };

        this.setState({
            filters: typing.extend(this.state.filters, newFilter),
            currentStaff: staff.STAFF,
            resetPage: true
        });
    }

    handleChangeDateFilter(event, newBeginDate, newEndDate) {
        event.preventDefault();
        let newFilter = {
            beginDate: newBeginDate,
            endDate: newEndDate
        };

        this.setState({
            filters: typing.extend(this.state.filters, newFilter),
            resetPage: true
        });
    }

    handleChangeOrganizationTypeFilter(type, event) {
        event.preventDefault();
        let newFilter = {
            idContentOrganizationType: type.IDCONTENTORGANIZATIONTYPE
        };

        this.setState({
            filters: typing.extend(this.state.filters, newFilter),
            currentOrganizationType: type.NAME,
            resetPage: true
        });
    }

    handleChange(event) {
        event.preventDefault();
        this.setState({
            searchTerm: event.target.value
        });
    }

    onKeyPressSearchFilter(event) {
        const self = this;
        if (event.which === 13) {
            self.handleOnChangeSearchFilter(event);
        }else{
            this.setState({
                resetPage:false
            });
        }
    }

    handleOnChangeSearchFilter(event) {
        event.preventDefault();
        let newFilter = {
            term: this.state.searchTerm
        };
        this.setState({
            filters: typing.extend(this.state.filters, newFilter),
            resetPage: true
        });
    } 

    render() {
        if (this.state.mode === Constants.MODE_LOADING) {
            return <WorkingLayer />
        }
        let dropdownStaff = this.state.staff.map(staff => <DropdownItem key={staff.IDSTAFF} className="dropdown-item" href="#" onClick={this.handleChangeValue.bind(this, staff)}>{staff.STAFF}</DropdownItem>)

        let dropdownOrganizationTypes = this.state.organizationTypes.map(organizationType => <DropdownItem key={organizationType.IDCONTENTORGANIZATIONTYPE} className="dropdown-item" href="#" onClick={this.handleChangeOrganizationTypeFilter.bind(this, organizationType)}>{organizationType.NAME}</DropdownItem>)

        return (
            <div className="activity-container margin-container"> 
                <div className="btn-group">
                    <div className="btn-group">
                        <InputSearchKeyword
                            searchKeyword={this.state.searchTerm}
                            handleChange={this.handleChange.bind(this)}
                            onKeyPressSearchFilter={this.onKeyPressSearchFilter.bind(this)} />
                    </div>
                    <ButtonDropdown isOpen={this.state.dropdownOpenTypes} toggle={this.toggleOrganizationType.bind(this)}>
                        <DropdownToggle className="dropdown-toggle-border" caret>
                            {this.state.currentOrganizationType}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem className="dropdown-item" href="#" onClick={this.handleChangeOrganizationTypeFilter.bind(this, { IDCONTENTORGANIZATIONTYPE: null, NAME: 'All Types' })}>
                                All Types
                            </DropdownItem>
                            {dropdownOrganizationTypes}
                        </DropdownMenu>
                    </ButtonDropdown >
                    <ButtonDropdown isOpen={this.state.dropdownOpenStaff} toggle={this.toggleStaff.bind(this)}>
                        <DropdownToggle caret>
                            {this.state.currentStaff}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem className="dropdown-item" href="#" onClick={this.handleChangeValue.bind(this, { IDSTAFF: null, STAFF: 'All Users' })}>
                                All Users
                            </DropdownItem>
                            {dropdownStaff}
                        </DropdownMenu>
                    </ButtonDropdown >
                    <DateFilter dropdownOpenDate={this.state.dropdownOpenDate}
                        onToggle={this.toggleDate.bind(this)}
                        selectedDateValue={this.state.selectedDateValue}
                        currentBeginDate={this.state.beginDate}
                        currentEndDate={this.state.endDate}
                        onChangeDate={this.handleChangeDateFilter.bind(this)} />
                </div>
                <div className="row">
                    <KeywordsAddedVsDeletedChart filters={this.state.filters} organizationTypes={this.state.organizationTypes} />
                    <KeywordsModifiedChart filters={this.state.filters} organizationTypes={this.state.organizationTypes} />
                    <RelationshipsAddedVsDeletedChart filters={this.state.filters} />
                </div>
                <div>
                    <KeywordsLog filters={this.state.filters} resetPage={this.state.resetPage} />
                </div>
            </div>
        );
    }
}